import * as React from 'react'

import { Box, Flex, Text } from '@chakra-ui/react'

import { Checkbox, Tag } from '@enechain/ecloud-designsystem'

import { ApiKeyRole } from '~/gen/proto/bff/v1/model_pb'
import { EndpointList } from '~/pages/ApiKeys/components/EndpointList'

type Props = {
  role: ApiKeyRole
  query: string
  isSelected: boolean
  onToggle: (roleName: string) => void
}

export const RoleCard: React.FC<Props> = ({
  role,
  query,
  isSelected,
  onToggle,
}) => {
  return (
    <Flex
      as="label"
      gap="3"
      padding="4"
      borderWidth="1px"
      borderColor={isSelected ? 'Border.accentPrimary' : 'Border.midEmphasis'}
      borderRadius="radiiLg"
      cursor="pointer"
      backgroundColor={isSelected ? 'Surface.accentPrimaryLightLow' : undefined}
    >
      <Checkbox
        checked={isSelected}
        onCheckedChange={(): void => {
          onToggle(role.name)
        }}
      />
      <Flex flexDirection="column" flex="1" gap="2" minWidth="0">
        <Flex alignItems="center" flexWrap="wrap" gap="2">
          <Text textStyle="headerSm">{role.name}</Text>
          {role.scopeName !== '' && (
            <Tag
              color="Text.accentPrimary"
              backgroundColor="Surface.accentPrimaryLightLow"
            >
              {role.scopeName}
            </Tag>
          )}
        </Flex>
        {role.description !== '' && (
          <Text color="Text.midEmphasis">{role.description}</Text>
        )}
        {role.endpoints.length > 0 && (
          <Box marginTop="1">
            <EndpointList endpoints={role.endpoints} highlightQuery={query} />
          </Box>
        )}
      </Flex>
    </Flex>
  )
}
